
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: { Table, Nodata },
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true
    })
    pageData.columns = [
      {
        title: '交易日期',
        dataIndex: 'time',
        key: 'time',
        width: '100px'
      },
      {
        title: '成交价(元)',
        dataIndex: 'DealPrice',
        key: 'DealPrice',
        width: '92px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '成交量(股)',
        dataIndex: 'InvolvedSum',
        key: 'InvolvedSum',
        width: '92px',
        ellipsis: true,
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '成交金额(元)',
        dataIndex: 'DealTurnover',
        key: 'DealTurnover',
        width: '100px',
        ellipsis: true,
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '买入营业部',
        dataIndex: 'BuyName',
        key: 'BuyName',
        ellipsis: true,
        slots: { customRender: 'ellipsis' },
        width: '200px'
      },
      {
        title: '卖出营业部',
        dataIndex: 'SellName',
        key: 'SellName',
        ellipsis: true,
        slots: { customRender: 'ellipsis' },
        width: '200px'
      }
    ]
    pageData.data = computed(() => {
      nextTick(() => {
        pageData.spinning = false
      })
      const _data = (props.pageSourceData || {}).LargeTran
      if ((_data || []).length < 1) return []
      _data.forEach((item: any, i: number) => {
        item.index = 'LargeTran' + i
        item.time = window.moment(item.TradeDay * 1000).format('YYYY-MM-DD')
      })
      return _data
    })
    return {
      ...toRefs(pageData)
    }
  }
})
